import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { getStoredUser, clearToken, setToken, setStoredUser } from './utils/api';
import Login from './pages/Login';
import SetupPassword from './pages/SetupPassword';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import SubmissionDetail from './pages/SubmissionDetail';
import AdminDashboard from './pages/AdminDashboard';
import Header from './components/Header';
import './App.css';

export default function App() {
  const [user, setUser] = useState(getStoredUser());
  const navigate = useNavigate();

  const handleLogin = (token, userData) => {
    setToken(token);
    setStoredUser(userData);
    setUser(userData);
    navigate(userData.role === 'admin' ? '/admin' : '/');
  };

  const handleLogout = () => {
    clearToken();
    localStorage.removeItem('mi_user');
    setUser(null);
    navigate('/login');
  };

  if (!user) {
    return (
      <Routes>
        <Route path="/login" element={<Login onLogin={handleLogin} />} />
        <Route path="/setup-password" element={<SetupPassword onLogin={handleLogin} />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    );
  }

  return (
    <div className="app">
      <Header user={user} onLogout={handleLogout} />
      <main className="main-content">
        <Routes>
          <Route path="/" element={<Dashboard user={user} />} />
          <Route path="/submissions/:id" element={<SubmissionDetail user={user} />} />
          {user.role === 'admin' && (
            <Route path="/admin" element={<AdminDashboard user={user} />} />
          )}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </main>
    </div>
  );
}
